import React from 'react';
import { TeamList } from '../../components/teams/TeamList';

const TeamsPage: React.FC = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <h1 className="text-3xl font-bold mb-6">Teams</h1>
      <TeamList />
    </div>
  );
};

export default TeamsPage; 